<template>
	<div class="projectManage" >
		<div class="header_ContentBox p-l-10 p-r-10">
			<i class="zb zb-orderManage Icon"></i>
			<span class="header_text">/ 企业管理 / 人员认证签约</span>
		</div>
		<div class="content_Box box-shadow" :style="{'min-height': windowSizeHeight-120 +'px'}">
			<div  class="p-l-10 p-r-10" style="height: 40px;">
				<div class="fl ">
					<span class="btnOK m-r-5" @click="resetBtn">全部人员</span>
					<span class="addOK m-r-5" @click="projectAbandon">新增人员</span>
				</div>
				<div class="fr"  >
					<div class="search_box fl" style="">
						<div class="fl s_companyName">
							<el-input v-model="s_companyName" placeholder="姓名/身份证/手机号码"></el-input>
						</div>
						<div class="fl s_type">
							<el-select v-model="s_CertificationStatus" placeholder="认证状态">
							    <el-option v-for="item in CertificationStatus" :key="item.id" :label="item.name" :value="item.id"> </el-option>
							</el-select>
						</div>
						<div class="fl s_type">
							<el-select v-model="s_SignStatus" placeholder="签约状态">
							    <el-option v-for="item in SignStatus" :key="item.id" :label="item.name" :value="item.id"> </el-option>
							</el-select>
						</div>
						<div class="fl s_type">
							<el-select v-model="s_BindingStatus" placeholder="绑卡状态">
							    <el-option v-for="item in BindingStatus" :key="item.id" :label="item.name" :value="item.id"> </el-option>
							</el-select>
						</div>
						<div class="fl s_submit cursor-pointer" @click="shearchBtn">搜索</div>
					</div>
				</div>
				
			</div>
			<template class="">
				<el-table :data="projectArr" stripe style="width: 100%" >
					<el-table-column label="#" width="160px">
						<template slot-scope="{row,$index}">
							<span class=" font-Tahoma ">{{row.project_sn}}</span>
						</template>
					</el-table-column>
					<el-table-column label="姓名" min-width="60px" :show-overflow-tooltip="true">
						<template slot-scope="{row,$index}">
							<span @click="gotToDetail(row)" class="cursor-pointer text-color-blue font-underline">{{row.name}}</span>
						</template>
					</el-table-column>
					<el-table-column label="手机号" align="right" width="60px">
						<template slot-scope="{row,$index}">
							<span @click="goOrderTask(row)" class="cursor-pointer text-color-blue font-weight-700 font-underline font-Impact">{{row.totality}}</span>
						</template>
					</el-table-column>
					<el-table-column label="身份证号码" align="right" width="160px">
						<template slot-scope="{row,$index}">
							<span v-if=" row.status=='1' " class="cursor-pointer font-underline cz-zf" @click="gotToDetail(row)">支付</span>
							<span v-else-if=" row.status=='2' " class="cursor-pointer font-underline text-color-green" @click="gotToDetail(row)">报审</span>
							<span v-else-if=" row.status=='5' " class="cursor-pointer font-weight-700 font-underline font-Impact text-color-blue" @click="goToOrderList(row)">{{row.totality}}</span>
							<span v-else-if=" row.status=='4' " class="cursor-pointer font-weight-700 font-underline font-Impact text-color-red" @click="goToOrderList(row)">{{row.totality-row.error_order}}</span>
							<span v-else-if=" row.status!='1' && row.status!='4' &&  row.status!='5'">/</span>
						</template>
					</el-table-column>
					<el-table-column prop="status" label="认证" align="center" width="120px">
						<template slot-scope="{row,$index}">
							<span v-if="row.status=='1'" class="xm-state-1">待支付</span>
							<span v-if="row.status=='2'" class="xm-state-2">待报审</span>
							<span v-if="row.status=='3'" class="xm-state-3">已驳回</span> 
							<span v-if="row.status=='4'" class="xm-state-4">结算{{  100 - (Number(row.error_order) / Number(row.totality) * 100 ).toFixed(2) }}%</span>
							<span v-if="row.status=='5'" class="xm-state-5">已结算</span>
							<span v-if="row.status=='6'" class="xm-state-6">审核中</span>
							<span v-if="row.status=='7'" class="xm-state-7">结算中</span>
							<span v-if="row.status=='8'" class="xm-state-8">已作废</span>
							<span v-if="row.status=='9'" class="xm-state-6">审核中</span>
							<span v-if="row.status=='10'" class="xm-state-10">签约异常</span>
							
						</template>
					</el-table-column>
					<el-table-column prop="settlement_money" align="right" label="签约" width="110px">
						<template slot-scope="{row,$index}">
							<p class="font-consolas font-weight-700">{{row.total_money | filterNumber}}</p>
						</template>
					</el-table-column>
					<el-table-column prop="settlement_money" align="right" label="绑卡" width="110px">
						<template slot-scope="{row,$index}">
							<span class="font-consolas font-weight-700">{{row.rate_money}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="" label="认证时间" align="center" width="170px">
						<template slot-scope="{row,$index}">
							<span class="font-Tahoma">{{row.start_time}} ~ {{row.end_time}}</span>
						</template>
					</el-table-column>
					<el-table-column label="签约时间" width="140px">
						<template slot-scope="{row,$index}">
							<span class="font-Tahoma">{{row.add_time}}</span>
						</template>
					</el-table-column>
					<el-table-column fixed="right" label="操作" width="240px">
						<template slot-scope="{row,$index}">
							<div>
								<a class="cz-font cz-sh cursor-pointer" @click="gotToEdit(row)">编辑</a>
								<span class="cz-line">|</span>
								<a class="cz-font cz-js cursor-pointer" @click="toUrl()">查看协议</a>
								<span class="cz-line">|</span>
								<a class="cz-font cz-qy cursor-pointer" @click="$router.push('/orderList')">相关订单</a>
								<span class="cz-line">|</span>
								<a class="cz-font cz-yhk cursor-pointer" @click="$router.push('/BankList')">银行卡</a>
							</div>
						</template>
					</el-table-column>
				</el-table>
				<!-- 分页 -->
				<div class="block regPagination">
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
					 :page-sizes="pageSize" :page-size="pageSizeNow" layout="total, sizes, prev, pager, next, jumper" :total="total">
					</el-pagination>
				</div>
			</template>
		</div>
		<!-- 新增人员信息-弹框 -->
		<el-dialog :title="dialogTitle" :visible.sync="dialogShow" width="630px" :close-on-click-modal="false">
			<div class="auditCentent">
				<div class="row_box ">
					<div class="fl"><i class="zb zb-asterisk icon-wjx"></i><span> 姓名：</span></div>
					<div class="fl w-430">
						<el-input v-model="a_name" placeholder=""></el-input>
					</div>
				</div>
				<div class="row_box ">
					<div class="fl"><i class="zb zb-asterisk icon-wjx"></i><span> 身份证号：</span></div>
					<div class="fl w-430">
						<el-input v-model="a_sfz" placeholder=""></el-input>
					</div>
				</div>
				<div class="row_box ">
					<div class="fl"><i class="zb zb-asterisk icon-wjx"></i><span> 手机号：</span></div>
					<div class="fl w-430">
						<el-input v-model="a_tel" placeholder=""></el-input>
					</div>
				</div>
				<div class="row_box ">
					<div class="fl"><i class="zb zb-asterisk icon-wjx"></i><span> 开户行：</span></div>
					<div class="fl w-430">
						<el-input v-model="a_openingbank" placeholder=""></el-input>
					</div>
				</div>
				<div class="row_box ">
					<div class="fl"><span> 分行/支行：</span></div>
					<div class="fl w-430">
						<el-input v-model="a_Branchbank" placeholder=""></el-input>
					</div>
				</div>
				<div class="row_box ">
					<div class="fl"><i class="zb zb-asterisk icon-wjx"></i><span> 银行卡号码：</span></div>
					<div class="fl w-430">
						<el-input v-model="a_yhknumber" placeholder=""></el-input>
					</div>
				</div>
				<div class="row_box ">
					<div class="fl"><span></span></div>
					<div class="fl w-430">
						<el-checkbox v-model="NoticeTag">短信通知签约</el-checkbox>
					</div>
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<span class="btnOK" @click="submitBtn">确定</span>
				<span class="resetBtn" @click="cancelBtn">取消</span>
			</div>
		</el-dialog>
		<!-- 编辑人员信息-弹框 -->
		<el-dialog :title="EditdialogTitle" :visible.sync="EditdialogShow" width="630px" :close-on-click-modal="false">
			<div class="auditCentent">
				<div class="row_box ">
					<div class="fl"><span> 姓名：</span></div>
					<div class="fl w-430">
						<span>欧阳娜娜</span>
					</div>
				</div>
				<div class="row_box ">
					<div class="fl"><span> 身份证号：</span></div>
					<div class="fl w-430">
						<span>510521199803131037</span>
					</div>
				</div>
				<div class="row_box ">
					<div class="fl"><i class="zb zb-asterisk icon-wjx"></i><span> 手机号：</span></div>
					<div class="fl w-430">
						<el-input v-model="b_tel" placeholder=""></el-input>
					</div>
				</div>
				<div class="row_box ">
					<div class="fl"><i class="zb zb-asterisk icon-wjx"></i><span> 开户行：</span></div>
					<div class="fl w-430">
						<el-input v-model="b_openingbank" placeholder=""></el-input>
					</div>
				</div>
				<div class="row_box ">
					<div class="fl"><span> 分行/支行：</span></div>
					<div class="fl w-430">
						<el-input v-model="b_Branchbank" placeholder=""></el-input>
					</div>
				</div>
				<div class="row_box ">
					<div class="fl"><i class="zb zb-asterisk icon-wjx"></i><span> 银行卡号码：</span></div>
					<div class="fl w-430">
						<el-input v-model="b_yhknumber" placeholder=""></el-input>
					</div>
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<span class="btnOK" @click="EditsubmitBtn">确定</span>
				<span class="resetBtn" @click="cancelBtn">取消</span>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		common
	} from '../../static/tool.js';
	import {
		mainfun
	} from '../assets/js/main.js';
	export default {
		name: 'projectManage',
		data() {
			return {
				url: common.url,
				windowSizeHeight: document.documentElement.clientHeight, //浏览器可视化窗口的大小
				projectArr: [
					{id: '1',name: '已认证'},
				], // 项目集合、
				token: window.sessionStorage.getItem('token'),
				//	分页
				total: 0, //总数
				pageNum: 1, //当前页
				pageSize: [10, 20, 50, 100], //每页展示条数
				pageSizeNow: 20, //当前每页多少行
				
				orderSort:'', //状态排序
				s_companyName:'', //搜索企业名称
				s_CertificationStatus:'', //认证状态
				s_SignStatus:'', //签约状态
				s_BindingStatus:'', //绑卡状态
				CertificationStatus: [//认证状态
					{id: '1',name: '已认证'},
					{id: '2',name: '未认证'},
				],
				SignStatus: [//签约状态
					{id: '1',name: '已签约'},
					{id: '2',name: '未签约'},
					{id: '3',name: '签约失败'},
				],
				BindingStatus: [//绑卡状态
					{id: '1',name: '已绑卡'},
					{id: '2',name: '未绑卡'},
				],
				dialogShow: false, //弹框
				dialogTitle: '',
				EditdialogShow: false, //弹框
				EditdialogTitle: '',
				a_name: '',
				a_sfz: '',
				a_tel: '',
				a_openingbank: '',
				a_Branchbank: '',
				a_yhknumber: '',
				NoticeTag: false,
				b_tel: '',
				b_openingbank: '',
				b_Branchbank: '',
				b_yhknumber: '',
			}
		},
		created() {
			if (!sessionStorage.getItem('userInfo')) { //判断是否登录
				window.location = 'login.html';
				return;
			}
			let pagingArr = JSON.parse(sessionStorage.getItem('pagingArr')); //分页存储
			if (pagingArr) {
				let paging = pagingArr.filter((val) => {
					return val.name == 'projectManage'
				})
				paging = paging[0]
				if (paging) {
					this.pageNum = paging.pageNum;
					this.pageSizeNow = paging.pageSizeNow;
					this.s_companyName = paging.s_companyName;
					this.s_type = paging.s_type; 
					this.startDate = paging.startDate; 
					this.endDate = paging.endDate; 
					this.s_dateAll = paging.s_dateAll;   //项目时间
					this.getProjectList(this.pageNum, this.pageSizeNow,this.s_companyName,this.s_type,this.startDate,this.endDate);
					sessionStorage.removeItem('pagingArr'); //清除分页存储 
				} else {
					this.getProjectList(this.pageNum, this.pageSizeNow,this.s_companyName,this.s_type,this.startDate,this.endDate);
				}
			} else {
				// this.getProjectList(this.pageNum, this.pageSizeNow,this.s_companyName,this.s_type,this.startDate,this.endDate);
				this.resetBtn()
			};
		},
		mounted() {
			this.startResult();
		},
		methods: {
			startResult() {

			},
			getProjectList() { //获取项目列表
				let fn = new FormData();
				fn.append('page', arguments[0]); //文件
				fn.append('pageSize', arguments[1]); //文件
				fn.append('name', arguments[2]); //项目名称
				fn.append('status', arguments[3]); //状态
				fn.append('start_time', arguments[4]); //开始时间
				fn.append('end_time', arguments[5]); //结束时间
				this.$http.post(this.url + '/zhongfy/company/ProjectList', fn).then((res) => {
					if (res.data.code == '200' || res.data.msg == '成功') {
						let data = res.data.data;
						this.projectArr = res.data.data.list
						this.total = res.data.data.total
					} else if (res.data.code == '8886') { //code   8886  登录过期
						sessionStorage.clear();
						this.$alert('登录已过期，请重新登录 !', '提示', {
							confirmButtonText: '确定',
							callback: action => {
								window.location = 'login.html';
							}
						});
						return;
					} else {
						this.$message.error(res.data.msg);
					}
				}, (res) => {
					this.$message.error('网络错误');
				})
			},
			// 详情
			gotToDetail(row) {
				let pagingArr = [];
				let paging = {
					name: 'projectManage',
					pageNum: this.pageNum,
					pageSizeNow: this.pageSizeNow,
					s_companyName: this.s_companyName,
					s_type: this.s_type,
					startDate: this.startDate,
					endDate: this.endDate,
					s_dateAll: this.s_dateAll, //项目时间
					
				};
				pagingArr.push(paging);
				sessionStorage.setItem('pagingArr', JSON.stringify(pagingArr)); //分页

				this.$router.push({
					path: '/projectNewDetail',
					query: {
						id: row.id
					}
				})
			},
			// 任务派单
			goOrderTask(row) {
				this.$router.push({
					path: '/orderTask',
					query: {
						pid: row.id
					}
				})
			},
			// 订单
			goToOrderList(row) {
				this.$router.push({
					path: '/orderList',
					query: {
						id: row.id
					},
			
				});
			},
			
			// 搜索
			shearchBtn(){
				this.pageNum = 1;
				this.getProjectList(this.pageNum, this.pageSizeNow,this.s_companyName,this.s_type,this.startDate,this.endDate);
			},

			resetBtn() { //重置
				this.pageNum = 1;
				this.s_type = '';
				this.s_dateAll = '';
				this.startDate = '';
				this.endDate = '';
				this.s_companyName = '';
				this.getProjectList(this.pageNum, this.pageSizeNow,this.s_companyName,this.s_type,this.startDate,this.endDate);
			},
			
			// 分页
			handleCurrentChange(val) { //切换页数
				this.pageNum = val;
				this.getProjectList(this.pageNum, this.pageSizeNow,this.s_companyName,this.s_type,this.startDate,this.endDate);
			},
			handleSizeChange(val) { //切换每页条数
				this.pageSizeNow = val;
				this.pageNum = 1;
				this.getProjectList(this.pageNum, this.pageSizeNow,this.s_companyName,this.s_type,this.startDate,this.endDate);
			},
			// 新增人员信息 
			projectAbandon() {
				this.dialogTitle = '新增人员信息',
				this.dialogShow = true;
			},
			// 编辑人员信息 
			gotToEdit(){
				this.EditdialogTitle = '编辑人员信息',
				this.EditdialogShow = true;	
			},
			//取消
			cancelBtn() { 
				this.dialogShow = false;
				this.EditdialogShow = false;
			},
			submitBtn() {
				if (
					this.a_name == '' || 
					this.a_sfz == '' || 
					this.a_tel == '' || 
					this.a_openingbank == '' || 
					this.a_yhknumber == ''
				) {
					this.$message.error('请填写必填项');
					return;
				}
			},
			EditsubmitBtn() {
				if (
					this.b_tel == '' || 
					this.b_openingbank == '' || 
					this.b_yhknumber == ''
				) {
					this.$message.error('请填写必填项');
					return;
				}
			},
			toUrl(){
				window.open('https://www.baidu.com/');
			}
		},
		filters: {
			
		}
	}
</script>

<style scoped>
	.demo-table-expand {font-size: 0;background: #f5f6fa;border: 1px solid #EBEEF5;padding: 15px !important;}
	.auditCentent i {font-size: 10px;}
	.auditCentent .row_box {min-height: 40px;}
	.auditCentent .row_box i {color: var(--theme-red);}
	.auditCentent .row_box>div:nth-child(1) {width: 110px;height: 40px;line-height: 40px;text-align: right;color: #666666;font-size: 12px;}
	.auditCentent .row_box>div:nth-child(2) {padding-left: 5px;height: 40px;line-height: 40px;color: var(--theme-black);font-size: 16px;}
	.auditCentent .reasonText {min-height: 90px;}
	.w-430{width: 430px;}
	.dialog-footer{text-align: left;padding-left: 114px;}
	.dialog-footer span{padding: 0 25px;}

	@media (max-width:767.78px) {
		.titleBox {height: 40px;}
	}
</style>



// WEBPACK FOOTER //
// src/components/PersonnelSigning.vue